















const ExcelJS = require("exceljs");

import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPagination } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import CoordinationSummarySearch from "@/components/report/TransportationCoordinationSearch.vue";
import ListView from "@/components/report/CoordinationSummaryList.vue";
import { GapCoordinationSummaryReportFilter } from "@/store/modules/types";
import App from "@/App.vue";

@Component({
  components: {
    BPagination,
    Header,
    EntityTabs,
    CoordinationSummarySearch,
    ListView,
  },
  computed: {
    ...mapState("gaps", ["filter"]),
  },
})
export default class CoordinationSummaryReport extends Vue {
  campaignId: string = "";
  reportFilter: any = this.defaultFilter();
  pageRows: Array<any> = [];
  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.getReport();
  }

  defaultFilter() : GapCoordinationSummaryReportFilter {
    return {
      insurerList: [],
      ipaList: [],
      priorityList: [],
      apptPriorityList: [],
      statusList: [],
      subStatusList: [],
      admissionDischargeList:[],
      referenceDate: {
        to: null,
        from: null,
      },
      campaignId: null,
    };
  }

  async getReport() {
    this.$store.commit("main/SET_LOADING", true);
    const { campaignId } = this.reportFilter;
    if( !this.reportFilter.campaignId){
      this.pageRows = [];
      this.$store.commit("main/SET_LOADING", false);
      return;
    }
    try {
      const data = await this.$store.dispatch(
        "gaps/getCoordinationSummaryReport",
         this.reportFilter
      );
      this.pageRows = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  get getDefaulthCampaign() {
    return this.$store.state.gaps.campaigns[0];
  }

   get getCampaignSelected() {
    return this.$store.state.gaps.campaigns.filter((c) => c.id === this.reportFilter.campaignId)[0];
  }

  get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }

  exportExcel() {
    var reportTitle = "COORDINATION SUMMARY REPORT";
    var subtitle = this.getCampaignSelected.name;
    var fileName =
      "coordination_summary_report_" + this.$moment().format("MMDDYYYY_hhmma");
    const reportDate = this.$moment()
      .format("MMM DD YYYY hh:mm A")
      .toUpperCase();
    const reportRangeDate ="";
    const medicalOffice = this.getEntity.name;
    const header = [
      "Contract Number",
      "Member Name",
      "Stage",
      "SubStatus",
      "Appt Priority",
      "IPA Name",
      "IPA Number",
      "NPI",
      "PCP Name",
      "Appointment Date",
      "Appointment Time",
      "Comment 1",
      "Comment 2",
      "Comment 3",
      "Comment 4"
    ];
    const font = {
      name: "Calibri",
      family: 2,
      size: 16,
      underline: false,
      bold: true,
    };
    const alignment = {
      vertical: "middle",
      horizontal: "right",
    };
    const data: any = [];
    var total = 0;
    const moment: any = this.$moment;
    for (const report of this.pageRows) {
      var row: any = [];
      row.push(report.contractNumber);
      row.push(report.memberName);
      row.push(report.stage);
      row.push(report.subStatus);
      row.push(report.apptPriority);
      row.push(report.ipaName);
      row.push(report.ipaNumber);
      row.push(report.NPI);
      row.push(report.pcpName);
      row.push(moment(report.appointmentDate).format("MM/DD/YYYY"));
      row.push( moment(report.appointmentTime, "HH:mm").format("h:mm A") );
      row.push(report.comment1);
      row.push(report.comment2);
      row.push(report.comment3);
      row.push(report.comment4);
      data.push(row);
    }
    //Create workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "PatientCare";
    workbook.lastModifiedBy = "PatientCare";
    workbook.created = new Date();
    workbook.modified = new Date();
    workbook.lastPrinted = new Date();

    const worksheet = workbook.addWorksheet("Report");

    //Add Row and formatting
    let reportTitleRow = (worksheet.getCell("G1").value = reportTitle);
    let reportDateRow = (worksheet.getCell("G2").value = reportDate);
    let medicalOfficeRow = (worksheet.getCell("G3").value = medicalOffice);
    let reportRangeDateRow = (worksheet.getCell("G4").value = reportRangeDate);

    // Set font, size and style in title row.
    worksheet.mergeCells("G1:I1");
    worksheet.mergeCells("G2:I2");
    worksheet.mergeCells("G3:I3");
    worksheet.mergeCells("G4:I4");

    worksheet.getCell("H1").font = font;
    worksheet.getCell("H2").font = font;
    worksheet.getCell("H3").font = font;
    worksheet.getCell("H4").font = font;

    worksheet.getCell("H1").alignment = alignment;
    worksheet.getCell("H2").alignment = alignment;
    worksheet.getCell("H3").alignment = alignment;
    worksheet.getCell("H4").alignment = alignment;

    //Add logo
    var img = new Image();

    img.onload = function () {
      var canvas: any = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(this, 0, 0);
      var dataURL = canvas.toDataURL("image/png");
      canvas = null;

      //Add Image
      let logo = workbook.addImage({
        base64: dataURL,
        extension: "png",
      });

      worksheet.addImage(logo, "A1:B4");
      worksheet.mergeCells("A1", "B4");

      // Blank Row
      worksheet.addRow([]);

      //Add waitingList row
      let subTitleRow = worksheet.addRow([subtitle]); //subtitle
      worksheet.mergeCells("A6:I6");

      subTitleRow.eachCell((cell, number) => {
        cell.border = {
          top: {
            style: "thin",
            color: {
              argb: "87CEEB",
            },
          },
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 14,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "87CEEB",
          },
          bgColor: {
            argb: "FFFFFF",
          },
        };
        cell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      //add data
      worksheet.addRows(data);

      //column width
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 30;
      worksheet.getColumn(3).width = 16;
      worksheet.getColumn(4).width = 16;
      worksheet.getColumn(5).width = 30;
      worksheet.getColumn(6).width = 16;
      worksheet.getColumn(7).width = 30;
      worksheet.getColumn(8).width = 30;
      worksheet.getColumn(9).width = 20;
      worksheet.getColumn(11).width = 20;
      worksheet.getColumn(13).width = 20;
      worksheet.getColumn(14).width = 20;
      worksheet.getColumn(15).width = 20;
      worksheet.getColumn(16).width = 20;
      worksheet.getColumn(17).width = 20;
      worksheet.getColumn(18).width = 20;
      worksheet.getColumn(19).width = 20;
      worksheet.getColumn(20).width = 60;
      worksheet.getColumn(21).width = 60;
      worksheet.getColumn(22).width = 60;
       worksheet.getColumn(23).width = 60;

      //Footer Row
      const footerFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FFFFFF",
        },
      };

      var emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);

      let footerRow = worksheet.addRow(["Total: " + data.length + " Members"]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow([
        "service@waitingmed.com · www.waitingmed.com",
      ]);
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      footerRow = worksheet.addRow(['15105 D John Delaney Drive Suite 317,Charlotte NC 28277'])
      footerRow.getCell(1).fill = footerFill;
      worksheet.mergeCells(`A${footerRow.number}:I${footerRow.number}`);

      footerRow.eachCell((cell, number) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        cell.font = {
          size: 12,
          color: {
            argb: "000000",
          },
          bold: true,
        };
      });

      emptyRow = worksheet.addRow([]);
      worksheet.mergeCells(`A${emptyRow.number}:I${emptyRow.number}`);
      //save
      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //app.saveAs(blob, fileName + '.xlsx');
        var url = window.URL.createObjectURL(blob);

        var doc = document.createElement("a");
        doc.href = url;
        doc.download = fileName + ".xlsx";
        doc.click();
        window.URL.revokeObjectURL(url);
      });
    };

    img.src = require("../assets/wmpc_logo.png");
  }

  clearFilter() {
    this.reportFilter = this.defaultFilter();
    this.$store.commit("gaps/RESET_FILTER");
    this.getReport();
  }

  mounted() {
    this.getReport();
  }
}
